export default __webpack_public_path__ + "media/color/taas-d36bae43.svg";